var map = {
	"./LoginConfirmBox": [
		21663
	],
	"./LoginConfirmBox.js": [
		21663
	],
	"./LoginConfirmBox.sass": [
		35877
	],
	"./ModalBaseCancelConfirm": [
		48633
	],
	"./ModalBaseCancelConfirm.js": [
		48633
	],
	"./ModalHooks": [
		91564
	],
	"./ModalHooks.js": [
		91564
	],
	"./ModalWrapper": [
		55175
	],
	"./ModalWrapper.js": [
		55175
	],
	"./ModalWrapperChildren": [
		24852
	],
	"./ModalWrapperChildren.js": [
		24852
	],
	"./parts/LayersActions/ModalEditLayer": [
		77156
	],
	"./parts/LayersActions/ModalEditLayer.js": [
		77156
	],
	"./parts/LayersActions/ModalEditLayer.module.sass": [
		70115
	],
	"./parts/ModalAcceptAllVerses": [
		55434,
		434
	],
	"./parts/ModalAcceptAllVerses.js": [
		55434,
		434
	],
	"./parts/ModalAddPages": [
		21658,
		658
	],
	"./parts/ModalAddPages.js": [
		21658,
		658
	],
	"./parts/ModalAddSubst": [
		23367
	],
	"./parts/ModalAddSubst.js": [
		23367
	],
	"./parts/ModalAutoTranscribePage": [
		33904,
		904
	],
	"./parts/ModalAutoTranscribePage.js": [
		33904,
		904
	],
	"./parts/ModalAutoTranscribePages": [
		55407,
		407
	],
	"./parts/ModalAutoTranscribePages.js": [
		55407,
		407
	],
	"./parts/ModalAutoTranscribeVerse": [
		94310,
		310
	],
	"./parts/ModalAutoTranscribeVerse.js": [
		94310,
		310
	],
	"./parts/ModalAvailableImportSources": [
		1131,
		131
	],
	"./parts/ModalAvailableImportSources.js": [
		1131,
		131
	],
	"./parts/ModalCommentsDelete": [
		30862,
		862
	],
	"./parts/ModalCommentsDelete.js": [
		30862,
		862
	],
	"./parts/ModalCommentsVerse": [
		6980,
		980
	],
	"./parts/ModalCommentsVerse.js": [
		6980,
		980
	],
	"./parts/ModalDLibraExportAccept": [
		52923,
		923
	],
	"./parts/ModalDLibraExportAccept.js": [
		52923,
		923
	],
	"./parts/ModalDLibraExportReject": [
		25501,
		78,
		501
	],
	"./parts/ModalDLibraExportReject.js": [
		25501,
		78,
		501
	],
	"./parts/ModalDeleteGroup": [
		60309,
		309
	],
	"./parts/ModalDeleteGroup.js": [
		60309,
		309
	],
	"./parts/ModalDeleteSelectedVerses": [
		13219,
		219
	],
	"./parts/ModalDeleteSelectedVerses.js": [
		13219,
		219
	],
	"./parts/ModalDeleteSelectedWords": [
		7300,
		300
	],
	"./parts/ModalDeleteSelectedWords.js": [
		7300,
		300
	],
	"./parts/ModalDeleteTranscriptionCallback": [
		14945,
		945
	],
	"./parts/ModalDeleteTranscriptionCallback.js": [
		14945,
		945
	],
	"./parts/ModalDeleteTranscriptionPage": [
		16609,
		609
	],
	"./parts/ModalDeleteTranscriptionPage.js": [
		16609,
		609
	],
	"./parts/ModalDeleteUserFromTranscription": [
		82051,
		51
	],
	"./parts/ModalDeleteUserFromTranscription.js": [
		82051,
		51
	],
	"./parts/ModalDeleteVerse": [
		54439,
		439
	],
	"./parts/ModalDeleteVerse.js": [
		54439,
		439
	],
	"./parts/ModalDeleteVerses": [
		93038,
		38
	],
	"./parts/ModalDeleteVerses.js": [
		93038,
		38
	],
	"./parts/ModalDeleteWord": [
		36924,
		924
	],
	"./parts/ModalDeleteWord.js": [
		36924,
		924
	],
	"./parts/ModalDownloadResults": [
		76934,
		553
	],
	"./parts/ModalDownloadResults.js": [
		76934,
		553
	],
	"./parts/ModalDownloadTranscriptionPage": [
		19948,
		948
	],
	"./parts/ModalDownloadTranscriptionPage.js": [
		19948,
		948
	],
	"./parts/ModalDropdown.module.sass": [
		42045
	],
	"./parts/ModalExportTextLayers": [
		10572,
		572
	],
	"./parts/ModalExportTextLayers.js": [
		10572,
		572
	],
	"./parts/ModalHistoricalPageNumber": [
		43153
	],
	"./parts/ModalHistoricalPageNumber.js": [
		43153
	],
	"./parts/ModalImportTextToLayer": [
		58455
	],
	"./parts/ModalImportTextToLayer.js": [
		58455
	],
	"./parts/ModalIndexesDelete": [
		60192,
		192
	],
	"./parts/ModalIndexesDelete.js": [
		60192,
		192
	],
	"./parts/ModalListOfIndex": [
		58396,
		396
	],
	"./parts/ModalListOfIndex.js": [
		58396,
		396
	],
	"./parts/ModalLoadTextTranscriptionPage": [
		64929,
		929
	],
	"./parts/ModalLoadTextTranscriptionPage.js": [
		64929,
		929
	],
	"./parts/ModalMarkTranscriptionPageAsEmpty": [
		84002,
		2
	],
	"./parts/ModalMarkTranscriptionPageAsEmpty.js": [
		84002,
		2
	],
	"./parts/ModalRegulations": [
		98287,
		287
	],
	"./parts/ModalRegulations.js": [
		98287,
		287
	],
	"./parts/ModalRejectAllVerses": [
		71007,
		7
	],
	"./parts/ModalRejectAllVerses.js": [
		71007,
		7
	],
	"./parts/ModalSendToDLibra": [
		84930,
		930
	],
	"./parts/ModalSendToDLibra.js": [
		84930,
		930
	],
	"./parts/ModalSetVerseAsIndex": [
		2176,
		581,
		176
	],
	"./parts/ModalSetVerseAsIndex.js": [
		2176,
		581,
		176
	],
	"./parts/ModalTrainOCR": [
		82773,
		773
	],
	"./parts/ModalTrainOCR.js": [
		82773,
		773
	],
	"./parts/Styles/ModalAutoTranscribePage.module.sass": [
		2306,
		306
	],
	"./parts/Styles/ModalDownloadResults.module.sass": [
		12179
	],
	"./parts/Styles/ModalDownloadTranscriptionPage.module.sass": [
		17496,
		496
	],
	"./parts/Styles/ModalLoadTextTranscriptionPage.module.sass": [
		92239,
		239
	],
	"./parts/Styles/ModalShowLayers.module.sass": [
		88834,
		834
	],
	"./parts/Styles/ModalTrainOCR.module.sass": [
		57093,
		93
	],
	"default/views/elements/Modal/LoginConfirmBox": [
		21663
	],
	"default/views/elements/Modal/LoginConfirmBox.js": [
		21663
	],
	"default/views/elements/Modal/LoginConfirmBox.sass": [
		35877
	],
	"default/views/elements/Modal/ModalBaseCancelConfirm": [
		48633
	],
	"default/views/elements/Modal/ModalBaseCancelConfirm.js": [
		48633
	],
	"default/views/elements/Modal/ModalHooks": [
		91564
	],
	"default/views/elements/Modal/ModalHooks.js": [
		91564
	],
	"default/views/elements/Modal/ModalWrapper": [
		55175
	],
	"default/views/elements/Modal/ModalWrapper.js": [
		55175
	],
	"default/views/elements/Modal/ModalWrapperChildren": [
		24852
	],
	"default/views/elements/Modal/ModalWrapperChildren.js": [
		24852
	],
	"default/views/elements/Modal/parts/LayersActions/ModalEditLayer": [
		77156
	],
	"default/views/elements/Modal/parts/LayersActions/ModalEditLayer.js": [
		77156
	],
	"default/views/elements/Modal/parts/LayersActions/ModalEditLayer.module.sass": [
		70115
	],
	"default/views/elements/Modal/parts/ModalAcceptAllVerses": [
		55434,
		434
	],
	"default/views/elements/Modal/parts/ModalAcceptAllVerses.js": [
		55434,
		434
	],
	"default/views/elements/Modal/parts/ModalAddPages": [
		21658,
		658
	],
	"default/views/elements/Modal/parts/ModalAddPages.js": [
		21658,
		658
	],
	"default/views/elements/Modal/parts/ModalAddSubst": [
		23367
	],
	"default/views/elements/Modal/parts/ModalAddSubst.js": [
		23367
	],
	"default/views/elements/Modal/parts/ModalAutoTranscribePage": [
		33904,
		904
	],
	"default/views/elements/Modal/parts/ModalAutoTranscribePage.js": [
		33904,
		904
	],
	"default/views/elements/Modal/parts/ModalAutoTranscribePages": [
		55407,
		407
	],
	"default/views/elements/Modal/parts/ModalAutoTranscribePages.js": [
		55407,
		407
	],
	"default/views/elements/Modal/parts/ModalAutoTranscribeVerse": [
		94310,
		310
	],
	"default/views/elements/Modal/parts/ModalAutoTranscribeVerse.js": [
		94310,
		310
	],
	"default/views/elements/Modal/parts/ModalAvailableImportSources": [
		1131,
		131
	],
	"default/views/elements/Modal/parts/ModalAvailableImportSources.js": [
		1131,
		131
	],
	"default/views/elements/Modal/parts/ModalCommentsDelete": [
		30862,
		862
	],
	"default/views/elements/Modal/parts/ModalCommentsDelete.js": [
		30862,
		862
	],
	"default/views/elements/Modal/parts/ModalCommentsVerse": [
		6980,
		980
	],
	"default/views/elements/Modal/parts/ModalCommentsVerse.js": [
		6980,
		980
	],
	"default/views/elements/Modal/parts/ModalDLibraExportAccept": [
		52923,
		923
	],
	"default/views/elements/Modal/parts/ModalDLibraExportAccept.js": [
		52923,
		923
	],
	"default/views/elements/Modal/parts/ModalDLibraExportReject": [
		25501,
		78,
		501
	],
	"default/views/elements/Modal/parts/ModalDLibraExportReject.js": [
		25501,
		78,
		501
	],
	"default/views/elements/Modal/parts/ModalDeleteGroup": [
		60309,
		309
	],
	"default/views/elements/Modal/parts/ModalDeleteGroup.js": [
		60309,
		309
	],
	"default/views/elements/Modal/parts/ModalDeleteSelectedVerses": [
		13219,
		219
	],
	"default/views/elements/Modal/parts/ModalDeleteSelectedVerses.js": [
		13219,
		219
	],
	"default/views/elements/Modal/parts/ModalDeleteSelectedWords": [
		7300,
		300
	],
	"default/views/elements/Modal/parts/ModalDeleteSelectedWords.js": [
		7300,
		300
	],
	"default/views/elements/Modal/parts/ModalDeleteTranscriptionCallback": [
		14945,
		945
	],
	"default/views/elements/Modal/parts/ModalDeleteTranscriptionCallback.js": [
		14945,
		945
	],
	"default/views/elements/Modal/parts/ModalDeleteTranscriptionPage": [
		16609,
		609
	],
	"default/views/elements/Modal/parts/ModalDeleteTranscriptionPage.js": [
		16609,
		609
	],
	"default/views/elements/Modal/parts/ModalDeleteUserFromTranscription": [
		82051,
		51
	],
	"default/views/elements/Modal/parts/ModalDeleteUserFromTranscription.js": [
		82051,
		51
	],
	"default/views/elements/Modal/parts/ModalDeleteVerse": [
		54439,
		439
	],
	"default/views/elements/Modal/parts/ModalDeleteVerse.js": [
		54439,
		439
	],
	"default/views/elements/Modal/parts/ModalDeleteVerses": [
		93038,
		38
	],
	"default/views/elements/Modal/parts/ModalDeleteVerses.js": [
		93038,
		38
	],
	"default/views/elements/Modal/parts/ModalDeleteWord": [
		36924,
		924
	],
	"default/views/elements/Modal/parts/ModalDeleteWord.js": [
		36924,
		924
	],
	"default/views/elements/Modal/parts/ModalDownloadResults": [
		76934,
		553
	],
	"default/views/elements/Modal/parts/ModalDownloadResults.js": [
		76934,
		553
	],
	"default/views/elements/Modal/parts/ModalDownloadTranscriptionPage": [
		19948,
		948
	],
	"default/views/elements/Modal/parts/ModalDownloadTranscriptionPage.js": [
		19948,
		948
	],
	"default/views/elements/Modal/parts/ModalDropdown.module.sass": [
		42045
	],
	"default/views/elements/Modal/parts/ModalExportTextLayers": [
		10572,
		572
	],
	"default/views/elements/Modal/parts/ModalExportTextLayers.js": [
		10572,
		572
	],
	"default/views/elements/Modal/parts/ModalHistoricalPageNumber": [
		43153
	],
	"default/views/elements/Modal/parts/ModalHistoricalPageNumber.js": [
		43153
	],
	"default/views/elements/Modal/parts/ModalImportTextToLayer": [
		58455
	],
	"default/views/elements/Modal/parts/ModalImportTextToLayer.js": [
		58455
	],
	"default/views/elements/Modal/parts/ModalIndexesDelete": [
		60192,
		192
	],
	"default/views/elements/Modal/parts/ModalIndexesDelete.js": [
		60192,
		192
	],
	"default/views/elements/Modal/parts/ModalListOfIndex": [
		58396,
		396
	],
	"default/views/elements/Modal/parts/ModalListOfIndex.js": [
		58396,
		396
	],
	"default/views/elements/Modal/parts/ModalLoadTextTranscriptionPage": [
		64929,
		929
	],
	"default/views/elements/Modal/parts/ModalLoadTextTranscriptionPage.js": [
		64929,
		929
	],
	"default/views/elements/Modal/parts/ModalMarkTranscriptionPageAsEmpty": [
		84002,
		2
	],
	"default/views/elements/Modal/parts/ModalMarkTranscriptionPageAsEmpty.js": [
		84002,
		2
	],
	"default/views/elements/Modal/parts/ModalRegulations": [
		98287,
		287
	],
	"default/views/elements/Modal/parts/ModalRegulations.js": [
		98287,
		287
	],
	"default/views/elements/Modal/parts/ModalRejectAllVerses": [
		71007,
		7
	],
	"default/views/elements/Modal/parts/ModalRejectAllVerses.js": [
		71007,
		7
	],
	"default/views/elements/Modal/parts/ModalSendToDLibra": [
		84930,
		930
	],
	"default/views/elements/Modal/parts/ModalSendToDLibra.js": [
		84930,
		930
	],
	"default/views/elements/Modal/parts/ModalSetVerseAsIndex": [
		2176,
		581,
		176
	],
	"default/views/elements/Modal/parts/ModalSetVerseAsIndex.js": [
		2176,
		581,
		176
	],
	"default/views/elements/Modal/parts/ModalTrainOCR": [
		82773,
		773
	],
	"default/views/elements/Modal/parts/ModalTrainOCR.js": [
		82773,
		773
	],
	"default/views/elements/Modal/parts/Styles/ModalAutoTranscribePage.module.sass": [
		2306,
		306
	],
	"default/views/elements/Modal/parts/Styles/ModalDownloadResults.module.sass": [
		12179
	],
	"default/views/elements/Modal/parts/Styles/ModalDownloadTranscriptionPage.module.sass": [
		17496,
		496
	],
	"default/views/elements/Modal/parts/Styles/ModalLoadTextTranscriptionPage.module.sass": [
		92239,
		239
	],
	"default/views/elements/Modal/parts/Styles/ModalShowLayers.module.sass": [
		88834,
		834
	],
	"default/views/elements/Modal/parts/Styles/ModalTrainOCR.module.sass": [
		57093,
		93
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51644;
module.exports = webpackAsyncContext;